module.exports = __webpack_public_path__ + "img/icon-warning.97a78ce6.svg";